export const it = {
  spinner: {
    default: "Caricamento dati in corso...",
    delayed: "Ci siamo quasi...",
  },
};
